import * as Types from '../actions/Types'

const INITIAL_STATE = {
  isUpdating: false,
  errorUpdating: null
}

export default (state = INITIAL_STATE, action) => {
  const { payload, type } = action

  switch (type) {
    case Types.UPDATE_LAUNDRY_RULES:
      return {
        ...state,
        isUpdating: true,
        errorUpdating: null
      }
    case Types.UPDATE_LAUNDRY_RULES_SUCCESS:
      return {
        ...state,
        isUpdating: false,
        errorUpdating: null
      }
    case Types.UPDATE_LAUNDRY_RULES_FAILED:
      return {
        ...state,
        isUpdating: false,
        errorUpdating: payload
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/components/reducers/LaundryRules.js